import { type FC } from "react";
import { FormItemName } from "@root/shared/components/FormItemName";
import { Grid } from "@root/shared/components/Grid";
import { InformationText } from "@root/shared/components/InformationText";
import { RadioWithLabel } from "@userFrontend/features/promotion/components/RadioWithLabel";
import { StepCassette } from "../StepCassette";
import * as styles from "./styles.css";
import { headingEmphasis } from "../../styles.css";

type Props = {
  jobTypeIdOptions: { label: string; value: string }[];
  jobTypeId?: string;
  errorMessage?: string;
  onChange: (value: string) => void;
};

export const Presentation: FC<Props> = ({
  jobTypeIdOptions,
  jobTypeId,
  errorMessage,
  onChange,
}) => {
  return (
    <StepCassette
      heading={
        <>
          今回診断する
          <br />
          あなたの<span className={headingEmphasis}>職種</span>を選んでください
        </>
      }
    >
      <FormItemName labelRequirementType="required">職種</FormItemName>
      <Grid columns={1} gapY={8} className={styles.radiosOuter}>
        {jobTypeIdOptions.map((option) => (
          <RadioWithLabel
            key={option.value}
            id={option.value}
            name="jobType"
            value={option.value}
            label={option.label}
            checked={jobTypeId === option.value}
            onChange={() => onChange(option.value)}
            hasError={!!errorMessage}
          />
        ))}
      </Grid>
      {errorMessage && (
        <InformationText text={errorMessage} isAlert className={styles.errorMessage} />
      )}
    </StepCassette>
  );
};
